import { inventoryHubCards, inventoryHubGroups } from '../../constants/inventoryHub'
import HubSection from './HubSection'
import QuickAccessCard from './QuickAccessCard'

const InventoryHub = ({ activeTab, onNavigateToSection }) => (
  <section className='rounded-[30px] border border-slate-200 bg-white p-4 shadow-[0_12px_28px_rgba(15,23,42,0.05)] md:p-5'>
    <div className='grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1.45fr)_minmax(0,0.9fr)]'>
      {inventoryHubGroups.map(group => (
        <HubSection
          key={group.key}
          title={group.title}
        >
          <div className='flex min-h-[106px] items-center gap-2 overflow-x-auto pb-1 md:flex-nowrap'>
            {group.cards.map(cardKey => {
              const card = inventoryHubCards[cardKey]
              if (!card) return null
              const isActive = activeTab === card.target

              return (
                <QuickAccessCard
                  key={cardKey}
                  title={card.title}
                  description={card.description}
                  infoText={card.infoText}
                  icon={card.icon}
                  tone={card.tone}
                  disabled={!card.target}
                  active={isActive}
                  onClick={card.target ? () => onNavigateToSection(isActive ? undefined : card.target) : undefined}
                />
              )
            })}
          </div>
        </HubSection>
      ))}
    </div>
  </section>
)

export default InventoryHub
